import { useEffect, useRef } from 'react';

export default function useUnmount(fn?: () => any): void {
  const fnRef = useRef(fn);

  // update ref store latest callback
  fnRef.current = fn;

  useEffect(() => {
    return () => (fnRef.current ? fnRef.current() : undefined);
  }, []);
}
